module.exports = __webpack_public_path__ + "static/media/remove.79ba6112.svg";